import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  loading: false,
  error: null,
  provinces: { data: [], loading: false, error: null },
  facilities: { data: [], loading: false, error: null },
};

//  Define slice and it's reducer functions.
const transferToFacilitySlice = createSlice({
  name: "transferToFacility",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProvinces(state, action) {
      state.provinces = {
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    setFacilities(state, action) {
      state.facilities = {
        data: action.payload.data,
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
    resetProvinces(state) {
      state.provinces = { loading: false, error: null, data: [] };
    },
    resetFacilities(state) {
      state.facilities = { loading: false, error: null, data: [] };
    },
  },
});

export const transferToFacilityAction = transferToFacilitySlice.actions;

export default transferToFacilitySlice;
